import zapSVG from '../assets/img/zap.svg';
import bookOpenSVG from '../assets/img/bookOpen.svg';
import eyeSVG from '../assets/img/eye.svg';
import brainSVG from '../assets/img/brain.svg';
import mousePointerClickSVG from '../assets/img/mousePointerClick.svg';
import focusSVG from '../assets/img/focus.svg'; 

window.VAE = window.VAE || {};

VAE.Profiles = (function () {
  'use strict';

  const ACCESSIBILITY_PROFILES = {
    seizure: {
      name: 'Anfallssicher',
      description: 'Reduziert Blitze & Animationen',
      icon: zapSVG,
      settings: {
        text: {
          fontSize: 1,
          lineHeight: 1,
          letterSpacing: 0,
          wordSpacing: 0,
        },
        colors: {
          // No color changes
        },
        motion: {
          reducedMotion: true,
          animationsDisabled: true,
          autoplayVideos: false,
          flashFilter: true,
        },
      },
    },
    vision: {
      name: 'Sehbehinderung',
      description: 'Verbessert die Lesbarkeit',
      icon: eyeSVG,
      settings: {
        text: {
          fontSize: 1.25,
          lineHeight: 1.4,
          letterSpacing: 1,
          wordSpacing: 2,
          highlightLinks: true,
          highlightHeadings: true,
        },
        colors: {
          highContrastLight: true,
          grayscale: false,
        },
        motion: {
          animationsDisabled: true,
          cursorSize: 'large',
          cursorOutline: 4,
          focusIndicator: true,
        },
      },
    },
    adhd: {
      name: 'ADHS-freundlich',
      description: 'Reduziert Ablenkungen',
      icon: focusSVG,
      settings: {
        text: {
          fontSize: 1.1,
          lineHeight: 1.3,
          letterSpacing: 0,
          wordSpacing: 0,
          readabilityMode: true,
        },
        colors: {
          grayscale: true,
        },
        motion: {
          animationsDisabled: true,
          autoplayVideos: false,
          smoothScrolling: false,
          focusIndicator: true,
          focusStyle: 'medium',
        },
      },
    },
    cognitive: {
      name: 'Kognitive Hilfe',
      description: 'Unterstützt beim Lesen',
      icon: brainSVG,
      settings: {
        text: {
          fontSize: 1.2,
          lineHeight: 1.5,
          letterSpacing: 1,
          wordSpacing: 4,
          highlightHeadings: true,
          easyLanguageOverlay: true,
        },
        colors: {
          grayscale: false,
        },
        motion: {
          animationsDisabled: true,
          focusIndicator: true,
          focusStyle: 'wide',
        },
      },
    },
    motor: {
      name: 'Motorische Hilfe',
      description: 'Erleichterte Bedienung',
      icon: mousePointerClickSVG,
      settings: {
        text: {
          fontSize: 1.1,
          lineHeight: 1.2,
          letterSpacing: 0,
          wordSpacing: 0,
          highlightLinks: true,
        },
        colors: {
          highlightInteractive: true,
          grayscale: false,
        },
        motion: {
          animationsDisabled: true,
          cursorSize: 'extralarge',
          cursorOutline: 6,
          focusIndicator: true,
          focusWidth: 4,
          interactivePadding: 4,
        },
      },
    },
    dyslexia: {
      name: 'Legasthenie',
      description: 'Optimiert für Legastheniker',
      icon: bookOpenSVG,
      settings: {
        text: {
          fontFamily: 'OpenDyslexic',
          fontSize: 1.15,
          lineHeight: 1.4,
          letterSpacing: 2,
          wordSpacing: 4,
          syllabication: false,
        },
        colors: {
          highContrastDark: true,
        },
        motion: {
          animationsDisabled: true,
          focusIndicator: true,
          focusStyle: 'wide',
          hoverDelay: 'long',
        },
      },
    },
  };

  let controlSetters = {};
  let subscriptionActive = false;

  function applyProfile(profileKey) {
    const profile = ACCESSIBILITY_PROFILES[profileKey];
    if (!profile || !profile.settings) {
      console.error(
        'VAE.Profiles: Invalid profile key or missing settings',
        profileKey
      );
      return;
    }

    if (profile.settings.text) {
      VAE.StateManager.updateState('text', profile.settings.text);
    }

    if (profile.settings.colors) {
      VAE.StateManager.updateState('colors', profile.settings.colors);
    }

    if (profile.settings.motion) {
      VAE.StateManager.updateState('motion', profile.settings.motion);
    }

    VAE.StateManager.setActiveProfile(profileKey);
  }

  function handleStateUpdate(activeKey) {
    console.log(
      `VAE.Profiles: Updating card selection, active key: ${activeKey}`
    );
    Object.keys(controlSetters).forEach((key) => {
      const setter = controlSetters[key];
      if (setter) {
        setter(key === activeKey);
      } else {
        console.warn(
          `VAE.Profiles: No setter found for profile card key: ${key}`
        );
      }
    });
  }

  function initStateManager() {
    if (subscriptionActive) return;

    if (typeof VAE.StateManager === 'undefined') {
      console.error('VAE.Profiles: StateManager not available yet, will retry');
      setTimeout(initStateManager, 100);
      return;
    }

    VAE.StateManager.subscribe('profile', handleStateUpdate);
    subscriptionActive = true;
  }

  function renderSectionContent(container) {
    if (!container) {
      console.error('VAE.Profiles: Profile cards container not provided.');
      return;
    }
    container.innerHTML = '';
    controlSetters = {};

    const currentProfile = VAE.StateManager.getState('profile');

    Object.keys(ACCESSIBILITY_PROFILES).forEach((key) => {
      const profile = ACCESSIBILITY_PROFILES[key];
      const profileCard = VAE.SharedUI.createProfileCard({
        profileKey: key,
        title: profile.name,
        description: profile.description,
        icon: profile.icon || '',
        isActive: currentProfile === key,
        onClick: (profileKey) => handleProfileSelection(profileKey),
      });

      controlSetters[key] = profileCard.setActive;
      container.appendChild(profileCard.card);
    });
  }

  function handleProfileSelection(profileKey) {
    if (!profileKey) return;

    const currentActiveProfile = VAE.StateManager.getState('profile');

    VAE.StateManager.resetAll();

    if (currentActiveProfile !== profileKey) {
      applyProfile(profileKey);
    }
  }

  function _init() {
    function checkStateManager() {
      if (typeof VAE.StateManager !== 'undefined') {
        initStateManager();
      } else {
        setTimeout(checkStateManager, 50);
      }
    }
    checkStateManager();
    return true;
  }

  _init();

  return {
    renderSectionContent,
    PROFILES: ACCESSIBILITY_PROFILES,
  };
})();